import axios from 'axios'
import { Object } from 'core-js';
import {makephoto} from '@/data/api';
import store from '@/store/index.js';
import { MessageBox } from 'mint-ui';
class Wechat {
    constructor() {
        this.scriptUrl = "https://res.wx.qq.com/open/js/jweixin-1.3.2.js"
        this.name = "wechat"
    }
    navigateTo(src) {
        wx.miniProgram.navigateTo({
            url:'/'+src
        });
    }
    switchTabTo(src) {
        wx.miniProgram.switchTab({
            url:'/'+src
        })
    }
    navigateBack() {
        wx.miniProgram.navigateBack({});
    }
    reLaunchTo(src) {
        wx.miniProgram.reLaunch({
            url:'/'+src
        });
    }
    redirectTo(src) {
        wx.miniProgram.redirectTo({
            url:'/'+src
        });
    }
    //判断当前环境是否是微信小程序
    isme() {
        let userAgent = window.navigator.userAgent;
        return window.__wxjs_environment === 'miniprogram' || /microMessenger/i.test(userAgent);
    }
    makePhoneCall(tel) {
        location.href=`tel://${tel}`;
    }
    qiyu(){
        location.href="https://wxlqkjyxgs.qiyukf.com/client?k=90d344f50c3d6ac29e60360bae8e8639&wp=1&robotShuntSwitch=1&robotId=3425033&sid=3889771"
    }
    gopay(path,data){
        let str = ``;
        Object.keys(data).forEach(item=>{
            if(item === "package"){
                data[item] = data[item].split("=")[1];
            }
            str+=`${item}=${data[item]}&`;
        })
        str = str.slice(0,-1);
        path+=`?${str}`;
        this.redirectTo(path);
    }
    //加入微信jssdk配置
    wxconfig(url) {
        let paramurl = location.href.split('#')[0];
        url+=`?url=${paramurl}`;
        axios.get(url).then(res => {
            console.log(res);
            let {appId, nonceStr, signature, timestamp} = res.data;
            wx.config({
                debug: false,
                appId,
                timestamp,
                nonceStr,
                signature,
                jsApiList: [
                    'chooseImage',
                    'previewImage',
                    'uploadImage',
                    'downloadImage',
                    'getLocalImgData'
                ]
            })
        })
    }

    //**********************自定义方法********************************** */
    chooseImage(counts,type){
        let count = counts ? counts : 1;
        type = type?type:'album'
        return new Promise((reslove,reject)=>{
            wx.chooseImage({
                count, // 默认9
                sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
                sourceType: [type], // 可以指定来源是相册还是相机，默认二者都有
                success: function (res) {
                    var localId = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                    reslove(localId);
                },
                fail(err){
                    // alert(JSON.stringify(err));
                    reject("查看相册失败");
                }
            });
        })
    }
    getLocalImgData(localIds){
        let arr = localIds.map(item => this.getLocalImgDatasingle(item))
        return Promise.all(arr)
    }
    getLocalImgDatasingle(localId){
        return new Promise((reslove,reject)=>{
            wx.getLocalImgData({
                localId: localId, // 图片的localID
                success: function (res) {
                    var localData = res.localData; // localData是图片的base64数据，可以用img标签显示
                    reslove(localData)
                },
                fail(){
                    reject("获取本地图片失败");
                }
            });
        })
    }
    feedbackphotos() {
        let loid = ""
        return this.chooseImage(4).then(res=>{
            loid = res;
            store.commit('SET_LOADING',true);
            return this.getLocalImgData(res)
        }).then(res=>{
            store.commit('SET_LOADING',false);
            let brr = []
            res.forEach((item,i) => {
                let obj = {
                    loid: loid[i],
                    url: item
                }
                brr.push(obj)
            })
            return brr;
        }).catch((err) => {
            store.commit('SET_LOADING',false);
            MessageBox.alert(err+'，请重新上传或联系管理员', '我知道了');
        })
    }
    takephoto(platform,spec_id,openid,type){
        type = type?type:'album'
        // this.navigateTo(`pages/miniApi/miniApi?description=takephoto&platform=${platform}&spec_id=${spec_id}&openid=${openid}`);
        // return Promise.reject("这是微信处理方式");
        return this.chooseImage(1,type).then(res=>{
            return this.getLocalImgData(res)
        }).then(res=>{
            let baseStr = res[0].replace(/^.*base64,/,'');
            store.commit('SET_LOADING',true);
            let fname = spec_id === 619?'asyncWeddingMakephoto':'asyncMakephoto'//619为结婚照规格
            return store.dispatch(fname,{
                spec_id:spec_id,
                file:baseStr
            })
        }).then(res=>{
            store.commit('SET_LOADING',false);
            console.log("res:::",res)
            return res;
        }).catch((err)=>{
            store.commit('SET_LOADING',false);
            return MessageBox({
                message:err+"。是否重新制作",
                title:'提示',
                confirmButtonText:'是',
                cancelButtonText:'否',
                showCancelButton:true
            }).then((action) => {
                if(action === 'confirm'){
                    return this.takephoto(platform,spec_id,openid,type);
                }else{
                    this.reLaunchTo('pages/index/index');
                }
            });
        });
        //store.dispatch('makephotos',{})
    }
    takecamera(platform,spec_id,openid) {
        if(spec_id===619){
            //结婚规格
            return this.takephoto(platform,spec_id,openid,'camera')
        }
        this.navigateTo(`pages/camera/camera?platform=${platform}&spec_id=${spec_id}&openid=${openid}`)
        return Promise.resolve({})
    }
    lookAdvertise(page) {
        this.navigateTo(page);
    }
    savePhone(orderId,platform) {
        this.navigateTo(`pages/miniApi/miniApi?description=savePhone&orderId=${orderId}&platform=${platform}`);
    }
}
export default new Wechat()